var _path, _path2, _line, _line2, _path3, _polyline, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8LinechartFile50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#90caf9",
    d: "M32.06,10H16.9c-1.6,0-2.9,1.3-2.9,2.9V43.1c0,1.6,1.3,2.9,2.9,2.9h21.34h0.87c1.6,0,2.9-1.3,2.9-2.9V19.99 c0-0.79-0.31-1.55-0.87-2.11l-6.94-6.99C33.63,10.32,32.86,10,32.06,10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M32.52,14.5H31.5c-1.1,0-2-0.9-2-2v-7"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.5,
    x2: 29.5,
    y1: 14.5,
    y2: 5.5,
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 38.5,
    x2: 38.5,
    y1: 38,
    y2: 14.5,
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M24,5.5H12.5c-1.66,0-3,1.34-3,3v2.02v5.87V36"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10.417,
    strokeWidth: 3,
    points: "9.5,42.5 16,36 24,41 31,32 38.5,38.5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 36,
    r: 3,
    fill: "#18193f"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 41,
    r: 3,
    fill: "#18193f"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 32,
    r: 3,
    fill: "#18193f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8LinechartFile50);
export default __webpack_public_path__ + "static/media/icons8-linechart-file-50.e1d558372c089a11726eddd350afeeba.svg";
export { ForwardRef as ReactComponent };